import type {
	SRT_Cell,
	SRT_ColumnMeta,
	SRT_RowData,
} from '../../../../../shared/components/master-table'

import {
	CheckboxCell,
	DateCell,
	MultiSelectCell,
	NumberCell,
	SelectCell,
	ShortTextCell,
} from './data-grid-cell-variants'

export function DataGridCellImpl<TData extends SRT_RowData>({
	cell,
	tableMeta,
}: {
	cell: SRT_Cell<TData>
	tableMeta: SRT_ColumnMeta
}) {
	const variant = cell.column.columnDef.meta?.variant ?? 'text'

	let Comp: React.ComponentType<any>

	switch (variant) {
		case 'text':
			Comp = ShortTextCell
			break
		case 'number':
			Comp = NumberCell
			break
		case 'boolean':
			Comp = CheckboxCell
			break
		case 'select':
			Comp = SelectCell
			break
		case 'multi-select':
			Comp = MultiSelectCell
			break
		case 'date':
			Comp = DateCell
			break

		default:
			Comp = ShortTextCell
			break
	}

	return <Comp cell={cell} tableMeta={tableMeta} />
}
